export class CheckIssuedCardResultVm {
  FirstName: string = "";
  LastName: string = "";
  DateOfBirth: string = "";
  PlaceOfBirth: string = "";

  CardNumber: string = "";
  CardStatus: string = "";
  CardIssuingAuthority: string = "";
  DriverLicenseNumber: string = "";
  CardFromDate: string = "";
  CardToDate: string = "";
  ValidForDriving: boolean = false;
  TemporaryCardSpecified: boolean = false;
}
